import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import memberStore from './memberStore'
import redirectUrlStore from './redirectUrlStore'
import myInfoStore from './myInfoStore'
import hospStore from './hospStore'
import patInfoStore from './patInfoStore'
import reserveStore from './reserveStore'

export default createStore({
    plugins: [
        createPersistedState({
            paths: ['memberStore', 'redirectUrlStore', 'myInfoStore', 'hospStore', 'patInfoStore', 'reserveStore']
        })
    ],
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        memberStore: memberStore,
        redirectUrlStore: redirectUrlStore,
        myInfoStore: myInfoStore,
        hospStore: hospStore,
        patInfoStore: patInfoStore,
        reserveStore: reserveStore
    }
})
